<template lang="pug">
  v-menu(top)
    template(v-slot:activator='{ on }')
      v-list-item-content.pa-0.pb-1
        v-list-item-title.centered(v-on='on') {{formatHeader()}}
    v-list
      v-list-item(v-for='restaurant  in myRestaurants' :key='restaurant.id' @click='vibrate();selectRestaurant(restaurant)')
        v-list-item-content
          v-list-item-title(v-if='selectedRestaurant && restaurant.id===selectedRestaurant.id')
            strong {{formatHeader(restaurant)}}
          v-list-item-title(v-else) {{formatHeader(restaurant)}}
</template>

<script>
import { storeMixin } from "../../mixins/storeMixin.js";
export default {
  name: "restaurant-selector",
  mixins: [storeMixin],
  async beforeMount() {
    this.myRestaurants = await this.allowedRestaurants;
  },
  data() {
    return {
      myRestaurants: []
    };
  },
  methods: {
    formatHeader(restaurant) {
      let r = restaurant || this.selectedRestaurant;
      return r ? r.code + ", " + r.name + ", " + r.addressLine2 : "Loading...";
    }
  }
};
</script>
 